import { MouseEventHandler } from "react"
import styles from "./MainButton.module.css"

interface mainButtonProps {
    active: boolean
    title: string
    onClick: MouseEventHandler<HTMLButtonElement> | undefined
}

export default function MainButton({active, title, onClick}: mainButtonProps) {
    return(
        <button onClick={onClick} type="submit" className={`${styles.btn} ${active ? styles.btnActive : ""}`}>{title}</button>
    )
}